import React, { useState } from "react";
import UserDashboard from "./UserDashboard";
import UserOrders from "./UserOrders";
import UserAddress from "./UserAddress";
import UserProfile from "./UserProfile";
import Header from "../components/Header";
import Footer from "../components/Footer";
function UserDashboardPage() {
    const [activeTab, setActiveTab] = useState("orders");
    const [openLogoutModal, setOpenLogoutModal] = useState(false);
    const renderContent = () => {
        switch (activeTab) {
            case "orders":
                return <UserOrders />;
            case "address":
                return <UserAddress />;
            case "profile":
                return <UserProfile />;
            case "logout":
                handleLogout();
            default:
                return <UserDashboard />;
        }
    };
    const handleLogout = () => {
        localStorage.removeItem("userToken");
        localStorage.removeItem("userID");
         localStorage.clear();
        window.location.href = "/";
    };
    return (
        <div className="page-container">
            <Header />
            <div className="dashboard-container">
                <div className="sidebar">
                    <h2>My Account</h2>
                    <ul>
                        {/* <li className={activeTab === "dashboard" ? "active" : ""} onClick={() => setActiveTab("dashboard")}>Dashboard</li> */}
                        <li className={activeTab === "orders" ? "active" : ""} onClick={() => setActiveTab("orders")}>Orders</li>
                        {/* <li className={activeTab === "address" ? "active" : ""} onClick={() => setActiveTab("address")}>Address</li> */}
                        <li className={activeTab === "profile" ? "active" : ""} onClick={() => setActiveTab("profile")}>Profile</li>
                        <li className={activeTab === "logout" ? "active" : ""} onClick={() => setOpenLogoutModal(true)}>Logout</li>
                    </ul>
                </div>
                <div className="dashboard-content">
                    {renderContent()}
                </div>
            </div>
            {openLogoutModal && (
                <div className="modal-overlay">
                    <div className="modal-box">
                        <h3>Confirm Logout</h3>
                        <p>Are you sure you want to logout?</p>
                        <div className="modal-actions">
                            <button className="cancel-btn" onClick={() => setOpenLogoutModal(false)}>Cancel</button>
                            <button className="confirm-btn" onClick={() => { setOpenLogoutModal(false); handleLogout(); }}>Logout</button>
                        </div>
                    </div>
                </div>
            )}
            <Footer />
        </div>
    );
}
export default UserDashboardPage;